import { Injectable } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { CustomerModel } from 'src/app/models/customer-model';
import { isUndefined } from '../codeUtils';
import { ConfigService } from '../config/config.service';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class WithdrawalService {
  public customer: CustomerModel;
  payoutMethodSubject: Subject<Object[]>;

  constructor(
    private userSession: UserSessionService,
    private webservice: WebservicesService,
    private config: ConfigService
  ) {
    this.payoutMethodSubject = new ReplaySubject(1);
    this.userSession.getCustomer().subscribe(
      (customer) => {
        this.customer = customer;
      }
    );
  }
  /*
* Get cashier/get-payout-methods
*/
  public callGetPayoutMethods() {
    this.webservice.get('cashier/get-payout-methods', { clientapp: this.config.getClientApp() }).subscribe(
      (resp: any) => {
        if (!!resp.result && resp.payload) {
          this.setPayoutMethods(resp.payload);
        }
      }
    );
  }

  setPayoutMethods(payload: any) {
    this.payoutMethodSubject.next(payload);
  }

  public getPayoutMethods() {
    return this.payoutMethodSubject;
  }

  callWithdraw(data: any) {
    const obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
      amount: data.amount,
      currency_code: data.currency_code,
      payment_type_code: data.payment_type_code
    }

    if (!isUndefined(data.customerAccountID)) {
      obj.customerAccountID = data.customerAccountID;
    }

    if (!isUndefined(data.isCagePayout)) {
      obj.isCagePayout = data.isCagePayout;
    }
    return this.webservice.post('cashier/withdraw', obj);
  }

  callWithdrawV2(data: any) {
    const obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
      amount: data.amount,
      currency_code: data.currency_code,
      payment_type_code: data.payment_type_code
    }

    if (!isUndefined(data.customerAccountID)) {
      obj.customerAccountID = data.customerAccountID;
    }

    if (!isUndefined(data.isCagePayout)) {
      obj.isCagePayout = data.isCagePayout;
    }
    return this.webservice.post('cashier/withdrawV2', obj);
  }

  callGetPendingWithdrawals() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
    }

    return this.webservice.post('cashier/get-pending-withdrawals', obj);
  }

  callReverseWithdrawal(data: any) {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
      payoutRequestID: data.payoutRequestID
    }

    return this.webservice.post('cashier/reverse-withdraw', obj);
  }

  callGetTotalWithdrawals() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken
    }

    return this.webservice.post('cashier/get-total-withdrawals', obj);
  }

  callSendTotalWithdrawals() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken
    }

    return this.webservice.post('cashier/send-total-withdrawals', obj);
  }

  callGetRejectedTransactions() {
    let obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.userSession.sessionToken,
    }

    return this.webservice.post('cashier/get-rejected-transactions', obj);
  }
}
